import { inject, Injectable, signal } from '@angular/core';
import { type Requisitioner } from '../models/requisitioner';
import { EFilingHttpService } from '../services/e-filing-http.service';
import { ToastService } from '../services/toast.service';

@Injectable({ providedIn: 'root' })
export class RequisitionerStore {
    private readonly http = inject<EFilingHttpService>(EFilingHttpService);
    private readonly toastService = inject<ToastService>(ToastService);

    public readonly requisitioners = signal<Record<string, Requisitioner[]>>(
        {}
    );
    public readonly loading = signal<boolean>(false);

    public load(): void {
        if (Object.keys(this.requisitioners()).length > 0) return;

        this.loading.set(true);
        this.http.getRequisitioners().subscribe({
            next: (data) => {
                this.requisitioners.set(data);
                this.loading.set(false);
            },
            error: () => {
                this.toastService.showErrorToast(
                    'Failed to load requisitioners'
                );
                this.loading.set(false);
            }
        });
    }
}
